import { mapActions } from 'vuex';
import constants from '@/constants';
import { isDebugOn } from '@/logger';

const levels = ['success', 'danger', 'warning', 'info'];

export default {
  props: {
    level: {
      type: String,
      default: 'success',
      validator: (value) => levels.indexOf(value) !== -1,
    },
    autoClose: {
      type: Boolean,
      required: false,
      default: true,
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: constants.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
    },
    onCloseCallback: {
      default: null,
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      interacted: false,
    };
  },
  computed: {
    contentModifiers() {
      return {
        'side-notification__content': true,
        [`side-notification__content--${this.level}`]: this.level,
      };
    },
    iconModifiers() {
      return {
        'side-notification__icon': true,
        [`side-notification__icon--${this.level}`]: this.level,
      };
    },
    isDebug() {
      return isDebugOn();
    },
    showAutoCloseLoader() {
      return this.autoClose && this.closeTimeout > 0 && !this.interacted && !this.isDebug;
    },
  },
  methods: {
    ...mapActions('notifications', ['clearSideNotification']),
    onClose() {
      this.clearSideNotification();
      if (typeof this.onCloseCallback !== 'undefined' && this.onCloseCallback !== null) {
        this.onCloseCallback.apply(this);
      }
    },
    onInteract() {
      this.interacted = true;
    },
  },
  mounted() {
    this.$el.addEventListener('click', () => this.onInteract());
    if (this.autoClose && !this.isDebug) {
      this.timeout = setTimeout(() => {
        if (!this.interacted) this.onClose();
      }, this.closeTimeout);
    }
  },
  beforeUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
};
